import { useTranslation } from "react-i18next";

const CampaignStatusTabs = ({ activeTab, onTabChange, counts }) => {
  const { t } = useTranslation();

  const tabs = [
    { id: "all", label: t("campaign.allCampaigns") },
    { id: "InProgress", label: t("InProgress") },
    { id: "Scheduled", label: t("Scheduled") },
    { id: "Completed", label: t("Completed") },
  ];

  return (
    <nav className="campaign-status-tabs" aria-label={t("Status")}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const count = tab.id === "all" ? counts.all : counts[tab.id] ?? 0;
        const showCount = tab.id !== "all";
        const label = showCount ? `${tab.label} (${count})` : tab.label;

        return (
          <button
            key={tab.id}
            type="button"
            className={`campaign-status-tabs__tab${isActive ? " campaign-status-tabs__tab--active" : ""}`}
            aria-current={isActive ? "page" : undefined}
            onClick={() => onTabChange(tab.id)}
          >
            {label}
          </button>
        );
      })}
    </nav>
  );
};

export default CampaignStatusTabs;
